(function () {
  'use strict';

  var FARBE_SELECTOR = '#roto-zrv-farbe';

  var CODE_TO_FILENAME = {
    V01: '1-V01-weissH0KLLzzPczl8Z_600x600_85496f35-7122-4e3b-843a-5e356d146a47.jpg',
    V02: '1-V02-hellbeige_600x600_e128234c-32b1-4f81-b0be-9fe98ea881fe.jpg',
    V03: '1-V03-beige_600x600_a68ece73-681b-4c21-b9f7-355ccf569be9.jpg',
    V04: '1-V04-braunbeige_600x600_2ff2b588-cc88-455a-b26e-7084668d74d2.jpg',
    V05: '1-V05-hellgrau_600x600_ffcff32f-310c-4e3e-930e-de9a957a74c9.jpg',
    V06: '1-V06-dunkelgrau_600x600_15e333b0-a6d4-43d1-8c60-c4cc19939067.jpg',
    V22: '2-V22-nachtblau_600x600_1cbc0c97-51a0-4f6b-890b-5406636fba5d.jpg',
    V24: '2-V24-petrol_600x600_dd420d73-50da-4faa-82ec-b2010787b3a1.jpg',
    V25: '2-V25-apfelgr-un_600x600_90c62127-b9f2-4527-96da-406b481f330d.jpg',
    V26: '2-V26-gelb_600x600_07f2b98d-bc74-4584-87da-fc5391923862.jpg',
    V31: '2-V31-braun_600x600_649fd680-ff4f-42de-93ae-f2430f64fc38.jpg',
    V32: '2-V32-schwarz_600x600_baaf71d6-6fda-4fa7-bdda-b5d276e85861.jpg',
    V51: '3-V51-Blumen-beige_600x600_f6b2eebf-8d72-432c-9ac7-b235b5fd24f6.jpg',
    V52: '3-V52-Linien-beige_600x600_badcc898-7f01-4aa6-9899-ae48839feecb.jpg',
    V53: '3-V53-Linien-schwarz_600x600_1bd378be-c050-46f8-a0c2-b35738b7e749.jpg',
    V56: '3-V56-Kreise-grau_600x600_d8431de1-2d74-400c-99d2-63d1cda6a247.jpg',
    V62: '3-V62-Sterne-marineblau_600x600_edcb72f9-0c81-4709-9142-d3816c1d7529.jpg'
  };

  function getSelect() {
    return document.querySelector(FARBE_SELECTOR);
  }

  function extractCode(value, label) {
    var m = (String(value || '') + ' ' + String(label || '')).match(/V\d{2}/i);
    return m ? m[0].toUpperCase() : null;
  }

  function getMainImage() {
    var direct = document.querySelector('img.product-image.img-fit');
    if (direct && direct.offsetParent !== null) return direct;

    var candidates = document.querySelectorAll('media-gallery img, .product-gallery img, .product__media img, .product-images img');
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && candidates[i].offsetParent !== null) return candidates[i];
    }
    return null;
  }

  function buildColorSrc(code) {
    var filename = CODE_TO_FILENAME[code];
    if (!filename) return null;
    return 'https://www.online-fenster-kaufen.de/cdn/shop/files/' + filename + '?width=640';
  }

  function swapForCurrentSelect() {
    var select = getSelect();
    if (!select) return;

    var opt = select.options && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    var code = extractCode(select.value, opt ? opt.textContent : '');
    if (!code) return;

    var src = buildColorSrc(code);
    if (!src) return;

    var mainImg = getMainImage();
    if (!mainImg) return;

    mainImg.src = src;
    mainImg.setAttribute('src', src);
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.alt = 'Roto ZRV Farbe ' + code;
    console.log('[H5 Image Sync] swapped ' + code);
  }

  function bind() {
    var select = getSelect();
    if (!select) return;

    select.addEventListener('change', swapForCurrentSelect);
    select.addEventListener('input', swapForCurrentSelect);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
